import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import TablePagination from "@mui/material/TablePagination";
import { ToastContainer, toast } from "react-toastify";
import { get_meeting_transcript, getMOMDetails, uploadMOM } from "../../api/User";
import "../Admin/table.css";
import {
  FirstPage,
  LastPage,
  KeyboardArrowLeft,
  KeyboardArrowRight,
} from "@mui/icons-material";
import Swal from "sweetalert2";
import html2pdf from "html2pdf.js";
import { Modal, Row, Col, Select } from "antd";
import loader from "../../Images/ajax-loader.gif";


const MahilaSabhaMOM = ({ dateFilter }) => {
  const userId = sessionStorage.getItem("user_id");
  const role_id = sessionStorage.getItem("role_id");
  const gpID = sessionStorage.getItem("gp_data");
  const token = sessionStorage.getItem("token");
  const [filteredData, setFilteredData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [openUploadModal, setOpenUploadModal] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [file, setFile] = useState(null);
  const [momDocument, setMomDocumentUrl] = useState(null);
  const [visible, setVisible] = useState(false);
  const [transcriptData, setTranscriptData] = useState(null);
  const [loading, setLoading] = useState(false);


  const fetchData = async () => {
    const data = {
      user_id: userId,
      meeting_type: "mahila_sabha",
    };
    try {
      const res = await getMOMDetails(token, data, 1, 10, dateFilter);
      if (res.status === "success") {
        const formattedData = res.data.map((item) => ({
          ...item,
          sabha_date: new Date(item.sabha_date).toISOString().split("T")[0],
          sabha_start_time: item.sabha_start_time.substring(0, 5),
        }));
        setFilteredData(formattedData);
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("An error occurred while fetching data.", {
        autoClose: 1000,
      });
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Re-fetch when dateFilter changes
  useEffect(() => {
    fetchData();
  }, [dateFilter]);

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    setFile(selectedFile);
    // if (
    //   selectedFile &&
    //   (selectedFile.type === "application/pdf" ||
    //     selectedFile.type ===
    //     "application/vnd.openxmlformats-officedocument.wordprocessingml.document")
    // ) {
    //   setFile(selectedFile);
    // } else {
    //   toast.error("Please select a valid PDF or DOCX file.", {
    //     autoClose: 2000,
    //   });
    // }
  };
  const handleUpload = async () => {
    if (!file || !selectedRowId) return;

    const formData = new FormData();
    formData.append("file", file);
    formData.append("id", selectedRowId);
    formData.append("fileType", file.type);

    try {
      const res = await uploadMOM(token, formData);
      if (res.status === "success") {
        toast.success("File uploaded successfully!", { autoClose: 1000 });
        setOpenUploadModal(false);
        fetchData();
        setFile(null);
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      setFile(null);
      console.error("Error uploading file:", error);
      toast.error("An error occurred while uploading the file.", {
        autoClose: 1000,
      });
    }
  };
  const openBase64File = (base64String, fileName) => {
    if (!base64String || !fileName) {
      Swal.fire({
        icon: "error",
        title: "File Not Uploaded",
        text: "No file available for this entry.",
        confirmButtonText: "OK",
      });
      return;
    }

    if (fileName.endsWith(".pdf")) {
      const byteCharacters = atob(base64String);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "application/pdf" });

      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl, "_blank");
    } else if (fileName.endsWith(".docx")) {
      const docxData = `data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,${base64String}`;
      window.open(docxData, "_blank");
    } else {
      Swal.fire({
        icon: "warning",
        title: "Unsupported File Type",
        text: "This file format is not supported for viewing.",
        confirmButtonText: "OK",
      });
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const paginatedData = filteredData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const handleCloseModal = () => {
    setVisible(false);
  };
  const handleView = async (id) => {
    setLoading(true)
    const data = {
      meeting_id: id,
    };
    try {
      const res = await get_meeting_transcript(token, data);
      if (res.status === "success") {
        setTranscriptData(res.data[0]);
        setLoading(false);
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("An error occurred while fetching data.");
    }
    setVisible(true);
  };

  const downloadPDF = () => {
    // Select the modal content excluding the download button
    const modalContent = document.querySelector(".ant-modal-body");

    // Define options for pdf generation
    const options = {
      margin: 10,
      filename: "meeting-transcript.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 4, letterRendering: true },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    };

    // Use html2pdf.js to convert the modal content to PDF
    html2pdf()
      .from(modalContent) // Only include modal content, excluding the button
      .set(options)
      .toPdf()
      .get("pdf")
      .then((pdf) => {
        // Save the generated PDF
        pdf.save("meeting-transcript.pdf");
      });
  };

  return (
    <>
      <div id="loading-coupon" style={{ display: loading ? "flex" : "none" }}>
        <img id="loading-image" src={loader} alt="Loading..." />
      </div>
      <style>
        {`
          .MuiTablePagination-actions svg {
            visibility: visible !important;
            fill: #212128;  
          }
        `}
      </style>
      <div className="container-fluid" style={{ height: "91vh" }}>
        <div>
          <h2
            className="pt-10"
            style={{ top: "0", left: "0", margin: "16px", fontWeight: "bold" }}
          >
            Mahila Sabha - Meeting
          </h2>
        </div>
        <hr style={{ margin: "20px 0", border: "2px solid #ddd" }} />
        <div
          style={{ overflowX: "auto", maxHeight: "84vh", marginTop: "20px" }}
        >
          <Table aria-label="simple table">
            <TableHead
              style={{
                position: "sticky",
                top: 0,
                zIndex: 1,
                backgroundColor: "rgb(232 233 246)",
              }}
            >
              <TableRow>
                <TableCell style={{ fontWeight: "bold" }} align="center">
                  SR NO.
                </TableCell>
                <TableCell style={{ fontWeight: "bold" }} align="center">
                  GRAM PANCHAYAT
                </TableCell>

                <TableCell style={{ fontWeight: "bold" }} align="center">
                  MEETING DATE
                </TableCell>
                <TableCell style={{ fontWeight: "bold" }} align="center">
                  MEETING TIME
                </TableCell>
                <TableCell style={{ fontWeight: "bold" }} align="center">
                  MEETING VENUE
                </TableCell>
                {/* <TableCell style={{ fontWeight: "bold" }} align="center">
                AGENDA
              </TableCell> */}
                <TableCell style={{ fontWeight: "bold" }} align="center">
                  MEETING VIDEO
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredData.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    No data found
                  </TableCell>
                </TableRow>
              ) : (
                paginatedData.map((row, index) => (
                  <TableRow key={row.id}>
                    <TableCell align="center">{index + 1}</TableCell>
                    <TableCell align="center">{row.gram_panchayat}</TableCell>

                    <TableCell align="center">{row.sabha_date}</TableCell>
                    <TableCell align="center">{row.sabha_start_time}</TableCell>
                    <TableCell align="center">{row.venue}</TableCell>
                    {/* <TableCell align="center" className="custom-class">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Dignissimos.
                </TableCell> */}
                    {/* <TableCell align="center" className="custom-class">
                    {!row.attachment_base64 || !row.mom_upload ? (
                      <Button variant="contained" sx={{ fontSize: 15, width: "40%", backgroundColor: "#4763E430", color: "#4763E4", "&:hover": { backgroundColor: "#4763E4", color: "#fff" } }}
                        onClick={() => {setSelectedRowId(row.id);setOpenUploadModal(true);}}
                      >
                        Upload
                      </Button>
                    ) : (
                      <Button variant="contained" sx={{ fontSize: 15, width: "40%", backgroundColor: "#4763E430", color: "#4763E4", "&:hover": { backgroundColor: "#4763E4", color: "#fff" } }}
                        onClick={() => openBase64File(row.attachment_base64, row.mom_upload)}
                      >
                        View
                      </Button>
                    )}
                  </TableCell> */}
                    <TableCell align="center" className="custom-class">
                      {!row.mom_upload ? (
                        <Button
                          variant="contained"
                          sx={{
                            fontSize: 15,
                            width: "40%",
                            backgroundColor: "#4763E430",
                            color: "#4763E4",
                            "&:hover": {
                              backgroundColor: "#4763E4",
                              color: "#fff",
                            },
                          }}
                          onClick={() => {
                            setSelectedRowId(row.id);
                            setOpenUploadModal(true);
                          }}
                        >
                          Upload
                        </Button>
                      ) : (
                        <Button
                          variant="contained"
                          sx={{
                            fontSize: 15,
                            width: "40%",
                            backgroundColor: "#4763E430",
                            color: "#4763E4",
                            "&:hover": {
                              backgroundColor: "#4763E4",
                              color: "#fff",
                            },
                          }}
                          onClick={() => {
                            // openBase64File(
                            //   row.attachment_base64,
                            //   row.mom_upload
                            // );
                            handleView(row.id);
                          }}
                        >
                          Genrate Transcript
                        </Button>
                      )}
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </div>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={filteredData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          showFirstButton
          showLastButton
          components={{
            FirstPageIcon: FirstPage,
            LastPageIcon: LastPage,
            NextPageIcon: KeyboardArrowRight,
            BackPageIcon: KeyboardArrowLeft,
          }}
        />
        {/* <Dialog
          open={openUploadModal}
          onClose={() => {
            setOpenUploadModal(false);
            setFile(null);
          }}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontWeight: "bold",
            }}
          >
            Upload Document
            <IconButton
              edge="end"
              color="inherit"
              onClick={() => {
                setOpenUploadModal(false);
                setFile(null);
              }}
              aria-label="close"
              style={{ position: "absolute", right: 15, top: 7 }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <form>
              <input
                type="file"
                accept=".pdf,.docx"
                onChange={handleFileChange}
                required
              />
              <div>
                <span style={{ color: "red" }}>
                  *Select your pdf/.docx file
                </span>
              </div>
              <div className="d-flex justify-content-end mt-3">
                <Button
                  variant="contained"
                  onClick={handleUpload}
                  disabled={!file || file == "" || file == null}
                  style={{
                    backgroundColor: "#5E63C7",
                    color: "#ffffff",
                    "&:hover": {
                      backgroundColor: "#323576",
                    },
                    width: "12%",
                  }}
                >
                  Upload
                </Button>
              </div>
            </form>
          </DialogContent>
        </Dialog>
        <Dialog
          open={!!momDocument && !momDocument.endsWith(".docx")}
          onClose={() => setMomDocumentUrl(null)}
          maxWidth="lg"
          fullWidth
        >
          <DialogTitle>
            View Document
            <IconButton
              edge="end"
              color="inherit"
              onClick={() => setMomDocumentUrl(null)}
              aria-label="close"
              style={{ position: "absolute", right: 15, top: 7 }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            {momDocument ? (
              momDocument.endsWith(".pdf") ? (
                <iframe
                  src={momDocument}
                  style={{ width: "100%", height: "500px" }}
                  title="Document Preview"
                />
              ) : (
                <p>
                  The file has been downloaded. Please visit the download
                  section to access it.
                </p>
              )
            ) : null}
          </DialogContent>
        </Dialog> */}

        <Dialog
          open={openUploadModal}
          onClose={() => {
            setOpenUploadModal(false);
            setFile(null);
          }}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontWeight: "bold",
            }}
          >
            Upload Video
            <IconButton
              edge="end"
              color="inherit"
              onClick={() => {
                setOpenUploadModal(false);
                setFile(null);
              }}
              aria-label="close"
              style={{ position: "absolute", right: 15, top: 7 }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <form>
              <input
                type="file"
                accept="video/mp4,video/mov,video/avi,video/MKV"
                onChange={handleFileChange}
                placeholder="Select your video file"
                required
              />
              <div>
                <span style={{ color: "red" }}>*Select your video file</span>
              </div>

              <div className="d-flex justify-content-end mt-3">
                <Button
                  variant="contained"
                  onClick={handleUpload}
                  disabled={!file || file === null}
                  style={{
                    backgroundColor: "#5E63C7",
                    color: "#ffffff",
                    "&:hover": {
                      backgroundColor: "#323576",
                    },
                    width: "12%",
                  }}
                >
                  Upload
                </Button>
              </div>
            </form>
          </DialogContent>
        </Dialog>
        <Modal
          className="mt-5"
          title={null}
          visible={visible}
          onCancel={handleCloseModal}
          footer={[
            <Button
              variant="contained"
              sx={{
                fontSize: 15,
                width: "20%",
                backgroundColor: "#4763E430",
                color: "#4763E4",
                "&:hover": {
                  backgroundColor: "#4763E4",
                  color: "#fff",
                },
              }}
              onClick={downloadPDF}
            >
              Download
            </Button>,
          ]}
          width={1200}
          centered
          zIndex={1050}
        >
          {/* Transcript Section */}
          <h5>Meeting Transcript</h5>
          <div
            style={{
              marginTop: "20px",
              border: "1px solid #dcdcdc",
              padding: "20px",
              borderRadius: "8px",
            }}
          >
            <div style={{ marginBottom: "20px" }}>
              <h5>English:</h5>
              <p>{transcriptData?.transcript_english}</p>
            </div>
            <div style={{ marginBottom: "20px" }}>
              <h5>Hindi:</h5>
              <p>{transcriptData?.transcript_hindi}</p>
            </div>
            <div style={{ marginBottom: "20px" }}>
              <h5>Punjabi:</h5>
              <p>{transcriptData?.transcript_punjabi}</p>
            </div>
          </div>

          <h5 className="mt-3" style={{ fontWeight: "500" }}>
            Meeting Summary
          </h5>

          <div
            style={{
              marginTop: "20px",
              border: "1px solid #dcdcdc",
              padding: "20px",
              borderRadius: "8px",
            }}
          >
            <div style={{ marginBottom: "20px" }}>
              <h5>English:</h5>
              <p>{transcriptData?.summary_english}</p>
            </div>
            <div style={{ marginBottom: "20px" }}>
              <h5>Hindi:</h5>
              <p>{transcriptData?.summary_hindi}</p>
            </div>
            <div style={{ marginBottom: "20px" }}>
              <h5>Punjabi:</h5>
              <p>{transcriptData?.summary_punjabi}</p>
            </div>
          </div>
        </Modal>
        <Dialog
          open={openUploadModal}
          onClose={() => {
            setOpenUploadModal(false);
            setFile(null);
          }}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontWeight: "bold",
            }}
          >
            Upload Video
            <IconButton
              edge="end"
              color="inherit"
              onClick={() => {
                setOpenUploadModal(false);
                setFile(null);
              }}
              aria-label="close"
              style={{ position: "absolute", right: 15, top: 7 }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <form>
              <input
                type="file"
                accept="video/mp4,video/mov,video/avi,video/MKV"
                onChange={handleFileChange}
                placeholder="Select your video file"
                required
              />
              <div>
                <span style={{ color: "red" }}>*Select your video file</span>
              </div>

              <div className="d-flex justify-content-end mt-3">
                <Button
                  variant="contained"
                  onClick={handleUpload}
                  disabled={!file || file === null}
                  style={{
                    backgroundColor: "#5E63C7",
                    color: "#ffffff",
                    "&:hover": {
                      backgroundColor: "#323576",
                    },
                    width: "12%",
                  }}
                >
                  Upload
                </Button>
              </div>
            </form>
          </DialogContent>
        </Dialog>
        <Modal
          className="mt-5"
          title={null}
          visible={visible}
          onCancel={handleCloseModal}
          footer={[
            <Button
              variant="contained"
              sx={{
                fontSize: 15,
                width: "20%",
                backgroundColor: "#4763E430",
                color: "#4763E4",
                "&:hover": {
                  backgroundColor: "#4763E4",
                  color: "#fff",
                },
              }}
              onClick={downloadPDF}
            >
              Download
            </Button>,
          ]}
          width={1200}
          centered
          zIndex={1050}
        >
          {/* Transcript Section */}
          <h5>Meeting Transcript</h5>
          <div
            style={{
              marginTop: "20px",
              border: "1px solid #dcdcdc",
              padding: "20px",
              borderRadius: "8px",
            }}
          >
            <div style={{ marginBottom: "20px" }}>
              <h5>English:</h5>
              <p>{transcriptData?.transcript_english}</p>
            </div>
            <div style={{ marginBottom: "20px" }}>
              <h5>Hindi:</h5>
              <p>{transcriptData?.transcript_hindi}</p>
            </div>
            <div style={{ marginBottom: "20px" }}>
              <h5>Punjabi:</h5>
              <p>{transcriptData?.transcript_punjabi}</p>
            </div>
          </div>

          <h5 className="mt-3" style={{ fontWeight: "500" }}>
            Meeting Summary
          </h5>

          <div
            style={{
              marginTop: "20px",
              border: "1px solid #dcdcdc",
              padding: "20px",
              borderRadius: "8px",
            }}
          >
            <div style={{ marginBottom: "20px" }}>
              <h5>English:</h5>
              <p>{transcriptData?.summary_english}</p>
            </div>
            <div style={{ marginBottom: "20px" }}>
              <h5>Hindi:</h5>
              <p>{transcriptData?.summary_hindi}</p>
            </div>
            <div style={{ marginBottom: "20px" }}>
              <h5>Punjabi:</h5>
              <p>{transcriptData?.summary_punjabi}</p>
            </div>
          </div>
        </Modal>
        <ToastContainer />
      </div>
    </>
  );
};
export default MahilaSabhaMOM;
